import AnalystDashboardPage from "@/pages/dashboard/AnalystDashboardPage";
import ScreeningsPage from "@/pages/screenings/ScreeningIndexPage";
import ScreeningPage from "@/pages/screenings/ScreeningPage";
import NewScreeningPage from "@/pages/screenings/NewScreeningPage";
import ProtectedRoute from "@/components/helpers/ProtectedRoute";

const AnalystRoutes = [
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <AnalystDashboardPage />,
      </ProtectedRoute>
    ),
  },
  {
    path: "screenings",
    element: (
      <ProtectedRoute>
        <ScreeningsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "screenings/new",
    element: (
      <ProtectedRoute>
        <NewScreeningPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "screenings/:screeningId",
    element: (
      <ProtectedRoute>
        <ScreeningPage />
      </ProtectedRoute>
    ),
  },
];

export default AnalystRoutes;
